import { Loader as o } from "../loader/loader.js";
const e = o;
export {
  e as Spinner
};
//# sourceMappingURL=spinner.js.map
